/**
 * LOEKZ='X' veya VISIBLE=0 olan event'ler UI'da devre dışı (gri, tıklanamaz) gösterilir.
 * Hiçbir event listeden silinmez; sadece görsel olarak pasifleştirilir.
 */
export const isEventDisabled = (event) => {
  if (!event) return true;

  const loekz = event.LOEKZ;
  const visible = event.VISIBLE;

  const isDeleted =
    loekz === 1 || loekz === '1' || loekz === true ||
    loekz === 'X' || loekz === 'x';

  const isInvisible =
    visible === 0 || visible === '0' || visible === false;

  return isDeleted || isInvisible;
};
